// extracted by mini-css-extract-plugin
export default {"copyLinkBtn":"actCompletionWorkPage_copyLinkBtn__6xbl0"};